var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMetricBarsGreen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 95,
    viewBox: "0 0 92 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.8125 26.5V94.5",
    stroke: "url(#paint0_linear_green_bars)",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8125 5.5V94.5",
    stroke: "url(#paint1_linear_green_bars)",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8125 47.5V94.5",
    stroke: "url(#paint2_linear_green_bars)",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8125 69.5V95.5",
    stroke: "url(#paint3_linear_green_bars)",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_green_bars",
    x1: 66.3125,
    y1: 26.5,
    x2: 66.3125,
    y2: 94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1DEB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF3ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_green_bars",
    x1: 84.3125,
    y1: 5.5,
    x2: 84.3125,
    y2: 94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1DEB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF3ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_green_bars",
    x1: 48.3125,
    y1: 47.5,
    x2: 48.3125,
    y2: 94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1DEB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF3ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_green_bars",
    x1: 30.3125,
    y1: 69.5,
    x2: 30.3125,
    y2: 95.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1DEB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF3ED"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMetricBarsGreen);
export default __webpack_public_path__ + "static/media/icMetricBarsGreen.cbf4fa0a9753fb0ff66167ff4c7883f5.svg";
export { ForwardRef as ReactComponent };